import { StageType } from "~/lib/org-stages/types";

export const PIPELINE_TEMPLATE_SCRATCH_ID = "tmp_start_from_scratch";

export const PIPELINE_CREATE_FORM_NAME = "pipeline-create-form";

export const PIPELINE_SETTINGS_STORAGE_KEYS = {
  TIPS: "show-hide-pipeline-stage-tips",
  VIEW: "pipeline-settings-view",
};

export const STAGE_TYPES = [
  {
    label: "Open",
    value: StageType.DEFAULT,
  },
  {
    label: "Won",
    value: StageType.POSITIVE,
  },
  {
    label: "Lost",
    value: StageType.NEGATIVE,
  },
];

export const STAGE_COLORS = [
  {
    label: "Slate",
    value: "slate",
  },
  {
    label: "Orange",
    value: "orange",
  },
  {
    label: "Amber",
    value: "amber",
  },
  {
    label: "Green",
    value: "green",
  },
  {
    label: "Violet",
    value: "violet",
  },
  {
    label: "Blue",
    value: "blue",
  },
  {
    label: "Pink",
    value: "pink",
  },
  {
    label: "Red",
    value: "red",
  },
];
